import { RangerSourceMapResolverBase } from './ranger-source-map.resolver.base';
import { RangerSourceMapService } from './ranger-source-map.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class RangerSourceMapResolver extends RangerSourceMapResolverBase {

  constructor(protected service: RangerSourceMapService) {
    super(service);
  }
}



